import { get } from 'lodash';

const styles = theme => ({
  appBar: {
    paddingTop: '24px',
    top: 'auto',
    bottom: 0,
    background: get(theme, 'color.uiBackground'),
    minHeight: '84px',
    position: 'fixed',
    width: 'auto !important',
    right: 0,
    left: 0,
    paddingBottom: '2px',
  },
  assistText: {
    color: get(theme, 'color.bodyText'),
    float: 'left',
    paddingTop: '5px',
    paddingRight: '8px',
  },
  cancelContainer: {
    paddingLeft: '30px',
  },
  cancelButton: {
    textTransform: 'none',
    color: get(theme, 'color.primaryButtonBackground'),
    backgroundColor: get(theme, 'color.primaryButtonText'),
    borderColor: get(theme, 'color.primaryButtonBackground'),
    lineHeight: get(theme, 'lineHeight.lh20'),
  },
  saveContainer: {
    float: 'right',
    paddingLeft: '30px',
    paddingRight: '30px',
  },
  saveButton: {
    textTransform: 'none',
    color: get(theme, 'color.primaryButtonText'),
    backgroundColor: get(theme, 'color.primaryButtonBackground'),
    borderColor: get(theme, 'color.primaryButtonBackground'),
    float: 'left',
    marginRight: '10px',
    lineHeight: get(theme, 'lineHeight.lh20'),
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/FormActionButtons/styles.js